import React, { useEffect, useState } from "react";
import Camera from "../../assets/icons/camera.svg";
import Box from "../../assets/icons/box.svg";
import AddCamera from "../../assets/icons/ic_add_a_photo.svg";
import { toast, ToastContainer } from 'react-toastify';
import video from '../../assets/videos/demo.mp4'

const RoomSelectionStep = ({ showModal, setShowModal, images, handleImageClick, setClickedImageKey, setImage, vendorColor }) => {
  const [imagePaths, setImagePaths] = useState([]);
  const handleFileChange = (e) => {
        const file = e.target.files[0]; // Get the first file
        if (file && file.size > 35000000) { // 35MB in bytes
            toast.error('Image size should be less than 35MB');
            e.target.value = null; // Reset the file input after error
        } else {
            setImage(file);
            handleImageClick();
        }
    };

  useEffect(() => {
    if (images && images.template_images) {
      const paths = Object.entries(images.template_images);
      setImagePaths(paths);
    }
  }, [images]);
  const closeIframe = () => {
    window.parent.postMessage("closeIframe", "*");
  };

  return (
    <div className="relative px-6 sm:px-12 pb-16 h-full overflow-auto">
      <div className="flex flex-col md:flex-row justify-between items-center w-full">
        <div className="w-full md:w-1/3 mb-4 md:mb-0">
          <h1 className="py-10 text-3xl font-semibold">See products in your room</h1>
          <div>
            <div>
            <div className="flex justify-start items-center gap-4 my-4">
              <img src={Camera} alt="" className="w-8 h-8" />
              <p className="text-xl font-normal">Upload a picture of your room</p> {/* Increased text size */}
            </div>

            <div className="flex justify-start items-center gap-4 my-4">
              <img src={Box} alt="" className="w-8 h-8" />
              <p className="text-xl font-normal">Try our products in your room</p> {/* Increased text size */}
            </div>

            </div>
            <button
              className={`upload-photo border rounded-md px-6 py-3 my-4 text-white font-semibold w-full hover:shadow-lg`}
              style={{ backgroundColor: vendorColor }}
            >
              <label htmlFor="file-upload" className="flex gap-1 items-center justify-center">
                <img src={AddCamera} alt="add-icon" className="w-8 h-8" />
                <h3 className="text-white">Upload</h3>
              </label>
              <input
                type="file"
                id="file-upload"
                style={{ display: "none" }}
                accept="image/*"
                onChange={handleFileChange}
              />
              <ToastContainer />
            </button>
          </div>
        </div>
        
        {/* Video section */}
        <div className="w-full md:w-2/3 flex justify-center items-center ml-10 mr-10">
          <video 
            width="100%"
            autoPlay
            loop
            muted
            playsInline
            controls={false}
            className="w-full max-w-[600px] h-auto rounded-lg shadow-lg"
          >
            <source src={video} type='video/mp4'></source>
            Your browser does not support the video tag.
          </video>
        </div>
      </div>
      
      <div>
        <h2 className="font-medium text-xl mb-5 mt-12 md:mt-12">Don't have a picture? Try our demo rooms instead</h2>
        <div className="pt-8 grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-8">
          {imagePaths && imagePaths.length > 0 ? (
            imagePaths.map(([key, src], index) => (
              <div key={key}>
                <img
                  onClick={() => {
                    setClickedImageKey(key);
                    handleImageClick();
                  }}
                  src={src}
                  alt={`Room ${index + 1}`}
                  className="rounded cursor-pointer hover:shadow-lg transition-all ease-in-out duration-500 object-cover h-64 w-full"
                />
                <h6 className="text-[#6A7078] text-[14px] font-semibold pt-1">Room {index + 1}</h6>
              </div>
            ))
          ) : (
            <p>No images available</p>
          )}
        </div>
      </div>
    </div>
  );
};
export default RoomSelectionStep;
